export default function InformationPolicy() {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-4 bg-gray-100 rounded-lg text-gray-900">
      <div className="max-w-3xl text-center bg-white p-4 rounded-lg shadow-lg">
        <h1 className="font-bold">ARKENOM TECHNOLOGY INFORMATION SECURITY POLICY</h1>
        <div>
          <h2 className="font-bold my-2">1. Purpose and Scope</h2>
          <p>
            This policy aims to protect the confidentiality, integrity, and availability of all digital assets, customer data, and business processes managed by Arkenom Technology. All visitors who use our website and our business partners are covered by this protection.
          </p>
        </div>
        <div>
          <h2 className="font-bold my-2">2. Our Core Principles</h2>
          <ul>
            <li><strong>Confidentiality:</strong> We ensure that information is protected against unauthorized access.</li>
            <li><strong>Integrity:</strong> We guarantee the accuracy of data and that it is stored without being altered.</li>
            <li><strong>Availability:</strong> We ensure that authorized users can access information whenever they need it.</li>
          </ul>
        </div>
        <div>
          <h2 className="font-bold my-2">3. Security Measures Implemented</h2>
          <ul>
            <li><strong>Data Encryption:</strong> All data traffic on our website is encrypted using SSL/TLS certificates.</li>
            <li><strong>Access Control:</strong> Access to our systems is restricted to necessary personnel only, based on the principle of “least privilege,” and strong authentication methods are used.</li>
            <li><strong>Updates and Monitoring:</strong> Our servers and software are regularly updated against known security vulnerabilities and are monitored 24/7.</li>
            <li><strong>Physical Security:</strong> Our data is hosted in certified data centers with high security standards.</li>
          </ul>
        </div>
        <div>
          <h2 className="font-bold my-2">4. User Responsibility</h2>
          <p>Users are responsible for choosing strong passwords for their accounts and must not share their login credentials with third parties.</p>
        </div>
        <div>
          <h2 className="font-bold my-2">5. Breach Notification</h2>
          <p>In the event of any suspected security breach, Arkenom Technology promptly analyzes the situation, notifies the relevant legal authorities (such as KVKK, where applicable), and informs the affected parties.</p>
        </div>
        <div>
          <h2 className="font-bold my-2">6. Contact</h2>
          <p>For any questions regarding our security policy, you may contact us at info@arkenom.com.tr</p>
        </div>
      </div>
    </div>
  );
}
